import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import { Provider } from 'react-redux';
import store from 'store';

const Providers: React.FC = ({ children }) => (
  <ConfigProvider locale={zhCN}>
    <Provider store={store}>
      <Router>{children}</Router>
    </Provider>
  </ConfigProvider>
);

export default Providers;
